import { createFileRoute, redirect } from '@tanstack/react-router'

/** Kept as a redirect — appearance moved to the My account surface. */
export const Route = createFileRoute('/_authenticated/$workspaceSlug/settings/appearance')({
  beforeLoad: ({ params }) => {
    throw redirect({ params, to: '/$workspaceSlug/account/appearance' })
  },
})
